import React from 'react';
import PropTypes from 'prop-types';

import Blog from '../components/Pages/Blog';

const BlogPage = props => {
  const blogPosts = props.data.allContentfulBlogPost.edges;
  const blogPageContent = props.data.allContentfulBlog.edges[0];
  return <Blog blogPageContent={blogPageContent} blogPosts={blogPosts} />;
};

BlogPage.propTypes = {
  data: PropTypes.object,
};

export default BlogPage;

export const enBlogQuery = graphql`
  query EnBlogQuery {
    # Blog page
    allContentfulBlog(filter: { node_locale: { eq: "en" } }) {
      edges {
        node {
          node_locale
          title
          description
          subTitle
          timeToRead
        }
      }
    }

    # Blog content
    allContentfulBlogPost(
      filter: { node_locale: { eq: "en" } }
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          node_locale
          date(formatString: "MM/DD/YYYY")
          heroPhoto {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          title
          slug
          childContentfulBlogPostPostTextNode {
            childMarkdownRemark {
              excerpt
              html
              timeToRead
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog.en.js